module.exports = __webpack_public_path__ + "static/media/DocBuilder.cfd2ccd3.png";